/**
 * Phase 4 — Winhouse Portal API client.
 * Uses cookie-based JWT (set by /api/auth/login) so we never expose tokens.
 */
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
const ax = axios.create({ baseURL: BACKEND_URL, withCredentials: true });

const unwrap = (p) => p.then((r) => r.data);

export const portalApi = {
  // self
  myDashboard:        () => unwrap(ax.get('/api/me/dashboard')),
  myStudentClasses:   () => unwrap(ax.get('/api/me/student/classes')),
  myStudentRecaps:    () => unwrap(ax.get('/api/me/student/recaps')),
  myStudentResources: () => unwrap(ax.get('/api/me/student/resources')),
  myTutorClasses:     () => unwrap(ax.get('/api/me/tutor/classes')),
  myTutorStudents:    () => unwrap(ax.get('/api/me/tutor/students')),
  myTutorRecaps:      () => unwrap(ax.get('/api/me/tutor/recaps')),

  // admin
  listUsers:     (params)        => unwrap(ax.get('/api/admin/users', { params })),
  createUser:    (body)          => unwrap(ax.post('/api/admin/users', body)),
  updateUser:    (id, body)      => unwrap(ax.patch(`/api/admin/users/${id}`, body)),
  resetPassword: (id, body = {}) => unwrap(ax.post(`/api/admin/users/${id}/reset-password`, body)),
  deactivate:    (id)            => unwrap(ax.delete(`/api/admin/users/${id}`)),
};

export default portalApi;
